<!--
 * @Author: yangzhiwei
 * @Date: 2022-08-26 14:55:02
 * @LastEditors: yangzhiwei
 * @LastEditTime: 2022-11-02 21:00:30
 * @Description:
-->
<template>
  <div class="file-card" @click="downloadFile(data)">
    <div class="file-info">
      <div class="file-name">{{ data.fileName }}</div>
      <div class="file-size">{{ getFileSize(data.fileSize) }}</div>
    </div>
    <div class="file-image" :class="getType(data.fileName)"></div>
  </div>
</template>
<script>
export default {
  name: 'FileCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    /**
     * 获取文件类型
     */
    getType(url) {
      const fileSuffix = url?.split('?')?.[0]?.split('.').reverse()[0]
      let type = ''
      switch (true) {
        case ['xlsx', 'xls'].includes(fileSuffix):
          type = 'excel'
          break
        case ['docx', 'doc'].includes(fileSuffix):
          type = 'word'
          break
        default:
      }
      return type
    },
    /**
     * 获取文件大小
     */
    getFileSize(fileSize) {
      if (!fileSize) {
        return '0 Bytes'
      }
      const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const index = Math.floor(Math.log(fileSize) / Math.log(1024))
      const size = (fileSize / Math.pow(1024, index)).toFixed(2)
      return size + unitArr[index]
    },
    /**
     * 下载文件
     */
    downloadFile(data) {
      if (data?.msg && data?.msg.startsWith('http')) {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', data.msg, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          const url = URL.createObjectURL(xhr.response)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', decodeURIComponent(data.fileName))
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          document.body.removeChild(link)
        }
        xhr.send()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .file-card {
    display: flex;
    width: 260px;
    cursor: pointer;
    .file-info {
      overflow: hidden;
      flex: 1 1;
      margin-right: 10px;
      .file-size {
        color: #999;
        line-height: 30px;
      }
    }
    .file-image {
      width: 45px;
      height: 45px;
      background: no-repeat center / contain;
      &.excel {
        background-image: url('../../../../common/image/icon_xlsx.png');
      }
      &.word {
        background-image: url('../../../../common/image/icon_word.png');
      }
    }
  }
</style>
